import React from "react";
import { Doughnut } from "react-chartjs-2";
import { doughnutOptions, horizontalBar } from "./_commonSharedChartOptions";
import { setColor } from "../../dashboard/ColorPalette";
import _ from "lodash";
import { connect } from "react-redux";
import { WidgetNoDataToDisplay, WidgetServerError } from "../../../../components/DashboardWidget/WidgetCommon";
import { missedUtterancesDataPreview } from "./_previewData";

const widgetProps = {
  Chart: "MISSED_UTTERANCES_LEX_SUMMARY",
  startDate: "04/18/2019%2012:00%20AM",
  endDate: "04/18/2019%208:00%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

const widgetDetails = {
  Chart: "MISSED_UTTERANCES_LEX",
  startDate: "04/18/2019%2012:00%20AM",
  endDate: "04/18/2019%208:00%20PM",
  skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
};

class RequestByPlatformPublic extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { widgetData, draggable } = this.props;
    return (
      <div>
        <div className="widgetTitle">Request by Public Users</div>
        <div className="widgetBody">
          {draggable ? (
            <WidgetServerError draggable={draggable} />
          ) : widgetData === undefined || draggable ? (
            <WidgetNoDataToDisplay draggable={draggable} />
          ) : (
            <Doughnut
              id={widgetDetails.Chart}
              data={{
                labels: widgetData.labels,
                datasets: [
                  {
                    data: widgetData.data,
                    backgroundColor: setColor(widgetData.labels)
                  }
                ]
              }}
              options={doughnutOptions}
            />
          )}
        </div>
      </div>
    );
  }
}

export const RequestByPlatformPublicPreview = () => {
  return (
    <div>
      <div className="widgetTitle">Request by Public Users</div>
      <div className="widgetBody">
        <Doughnut
          data={missedUtterancesDataPreview}
          options={_.merge({}, doughnutOptions, {
            legend: {
              labels: {
                boxWidth: 5,
                fontSize: 8,
                padding: 2.5
              }
            },
            plugins: {
              datalabels: {
                font: {
                  size: 7
                }
              }
            }
          })}
        />
      </div>
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    widgetData: state.dashboard.data["RequestPerUserPublic"]
  };
}

export const RequestByPlatformPublicContent = connect(
  mapStateToProps,
  undefined
)(RequestByPlatformPublic);
